<template>
  <div class="empty-view">
    <div class="loading-overlay">
      <span class="loader">
        <icon icon="x-fa-spinner-third"> </icon>
      </span>
    </div>
    <div class="heading">
      <icon v-if="icon" :icon="icon"> </icon>
      <span class="title">
        <slot name="heading">
          <span> Geen producten gevonden </span>
        </slot>
      </span>
    </div>
    <div class="message">
      <slot name="message">
        Er konden helaas geen producten worden gevonden met je huidige filter
        opties. Klik op 'terug' om je vorige selectie te zien of start een chat
        met een van onze collega's.
      </slot>
    </div>
    <div class="buttons">
      <span class="button primary" role="button" @click="$emit('reset')">
        <div class="label">Terug</div>

        <icon icon="x-fa-redo-alt"></icon>
      </span>
      <a @click="openChatProxy" class="button secondary" role="button">
        <div class="label">Chat</div>
        <icon icon="chat"></icon>
      </a>
    </div>
  </div>
</template>

<style lang="scss">
@use 'templates/elements/link/button/_shared/_link.scss';
@use 'assets/scss/_helpers/border' as border;
@use 'assets/scss/_helpers/background'as background;
@use 'assets/scss/_helpers/loader'as loader;
@use 'assets/scss/_helpers/display'as display;
@use 'assets/scss/_helpers/breakpoint'as breakpoint;
@use 'assets/scss/_helpers/typography'as typography;
@use 'assets/scss/_helpers/icon'as icon;
@use 'assets/scss/_helpers/z-index'as z-index;
@use 'assets/scss/_variables/typographies'as typographies;
@use 'assets/scss/_variables/colors'as colors;

.empty-view {
  @include border.radius(xl);
  @include background.light;

  transition-delay: none !important;
  box-shadow: inset 0 0 5px rgb(0 0 0 / 5%);
  padding: 32px;
  grid-column: 1 / span 2;
  text-align: center;
  position: relative;
  overflow: hidden;

  .loading-overlay {
    @include display.flex-col-center();
    @include z-index.component();

    background: rgba(255, 255, 255, 0.4);
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    display: none;

    .loader {
      @include loader.spinner();
    }
  }

  .heading {
    @include icon.color(#005e7b);
    @include display.flex-row-center;

    margin-bottom: 12px;
  }

  .title {
    @include typography.font(typographies.$headings, h4);

    color: #005e7b;
    margin-left: 8px;
  }

  .message {
    @include typography.font((16px, 24px, 500));

    margin-bottom: 24px;
  }

  .buttons {
    display: grid;
    justify-content: center;
    grid-gap: 12px;

    @include breakpoint.up(md) {
      grid-gap: 24px;
      grid-template-columns: auto auto;
    }
  }

  .button {
    @extend %button;

    justify-content: space-between;
    min-width: 160px;

    &.primary {
      @extend %button--primary;
    }

    &.secondary {
      @extend %button--secondary;
    }
  }
}

.is-loading .empty-view {
  .loading-overlay {
    display: flex;
  }

  .loader {
    @include loader.play;
  }
}
</style>

<script>
import Icon from "../icon/Icon.vue";
import { openChat } from '../../../assets/js/helpers/chat';

export default {
  props: ["icon"],
  components: {
    Icon,
  },
  methods: {
    openChatProxy(e) {
      openChat(e.currentTarget);
    },
  },
};
</script>

